//export const apiUrl = "https://api.doctorsplus.net";
export const apiUrl = "https://9dnr40cv-4001.inc1.devtunnels.ms";
export const s3Url = "https://alex-pph-bucket.s3.eu-north-1.amazonaws.com";
export const imageUrl = (url) => `${s3Url}/${url}`;
export const mediaUrl = (url) => `${s3Url}/${url}`;

export const BaseURL = (link) => {
  return `${apiUrl}/api/v1/${link}`;
};
export const recordsLimit = 10;
// live
